import React, { Component } from "react";
import { Pagination, Header, Segment } from "semantic-ui-react";
import ActionButton from "./actionButton";
import TitleBar from "../titleBar/title_bar";
import TitleBarDelivery from "../delivery/deliveryheader";
import { AgGridReact } from "ag-grid-react";
import { AllModules } from "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import CustomNoRowsOverlay from "./customNoRowsOverlay.js";
import { translate } from "react-i18next";
import ModalEditAddDeliveries from "../createShipmentComponent/modalEditAddDeliveries";
import CreatAxios from "../axiosComponent/create";
import cogoToast from "cogo-toast";
import ReadAxios from '../../components/axiosComponent/read'
import {licenseKey} from '../../utils/constant'
import {noDataToExportDeliveries} from '../../utils/toastMsgConstant'
import {NO_RECORDS_FOUND, DELIVERY_UPDATE_SUCCESS_MESSAGE} from '../../utils/validationConstant'
LicenseManager.setLicenseKey(
  licenseKey
);

class DeliveryAgGridTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMovementType: 'primary',
      modules: AllModules,
      openModalDelivery: false,
      defaultColDef: {
        flex: 1,
        minWidth: 100,
        statusLoading: false,
        enableValue: true,
        resizable: true,
        enableRowGroup: true,
        enablePivot: true,
      },
      sideBar: {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
          },
          {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
          },
        ],
        defaultToolPanel: "",
      },
      isLoading: true,
      rowData: [],
      searchValue: "",
      // ag grid custom overlay
      frameworkComponents: {
        actionRenderer: ActionButton,
        customNoRowsOverlay: CustomNoRowsOverlay,
        ...this.props.extraComponents
      },
      noRowsOverlayComponent: "customNoRowsOverlay",
      noRowsOverlayComponentParams: {
        noRowsMessageFunc: function () {
          return NO_RECORDS_FOUND;
        },
      },
      filtersApplied : ""
    };
  }

  handleChange = (e) => {
    this.setState({ searchValue: e.target.value });
  };

  addNewDeliveryModal = (data) => {
    this.setState({ openModalDelivery: data });
  }

  setOpenModalDeliveryClose = () => {
    this.setState({ openModalDelivery: false });
  }

  addDeliveryDetails = (data) => {
    CreatAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/null/create`,
      payload: { deliveries: data }
    }).then((response) => {
      if (response.data.status == 1) {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: DELIVERY_UPDATE_SUCCESS_MESSAGE,
        };
        cogoToast.success(response.data?.message , {position:"top-right"});
        setTimeout(()=>{
          window.location.reload();
        },1000)
      }else{
        cogoToast.error(response.data?.message , {position:"top-right"});
      }

    })
      .catch((err) => {
        console.log(err);
      });
  }

  getParams() {
    return {
      columnGroups: true,
      fileName: this.props.titleBarTitle,
    };
  }

  onBtnExportDataAsExcel = () => {
    var params = this.getParams();
    this.gridApi.exportDataAsExcel(params);
  };

  onGridReady = (prams) => {
    // console.log("ag grid is read ", prams);
    this.gridApi = prams.api;
    this.setState({
      isLoading: this.props.isLoading,
    });
    prams.columnApi.autoSizeAllColumns('', false);
    this.gridColumnApi = prams.columnApi;
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds);
    // this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    // if (this.props.sizeColumnsToFit) prams.api.sizeColumnsToFit();
  };

  componentDidMount() {
    this.setState({ statusLoading: true })
    setTimeout(() => {
      this.setState({ statusLoading: false })
    }, 2000);
  }

  importDataGrid = () => {
    // console.log("import the data grid");
  };

  exportDataGrid = () => {
    if(!this.props.rowData.length){
      cogoToast.error(noDataToExportDeliveries);
    }else{
      let booking_branch_ids = localStorage.getItem('branchIds')?.length > 0 ? localStorage.getItem('branchIds').toString()
      : ''
      let Id, idValue
      if (localStorage.getItem('consignorId')) {
        Id = 'consignor_id'
        idValue = localStorage.getItem('consignorId')
      }else if (localStorage.getItem('consigneeId')) {
        Id = 'consignee_id'
        idValue = localStorage.getItem('consigneeId')
      }
      let filter_url = ""
      if(this.state.filtersApplied){
        let filtersApplied = this.state.filtersApplied
        filter_url = `delivery_reference_no=${filtersApplied.delivery_reference_no}&invoice_no=${filtersApplied.invoice_no}&invoice_reference_no=${filtersApplied.invoice_reference_no}&lr_no=${filtersApplied.lr_no}`
      }
      ReadAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/export?page=${this.props.currentPage}&booking_branch_ids=${booking_branch_ids}&${Id}=${idValue}&${filter_url}`,
      }) .then((res) => {
        cogoToast.success(res.data.message);
      })
      .catch((err) => {
        console.log("err", err);
      });
    }
  };

  filterChanged = (e) => {
    if (this.gridApi.getDisplayedRowCount() === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  };

  autoSizeAll = (skipHeader) => {
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  };

  handleMetaSearch = (data) => {
    this.setState({filtersApplied : data})
    this.props.handleMetaSearch(data);
  };

  handleMovementType = (movementType) => {
    this.setState({ selectedMovementType: movementType });
  };

  render() {
    const { frameworkComponents } = this.state;
    const { t } = this.props;
    // if (this.props.isLoading === true) {
    //   return (
    //     <React.Fragment>
    //       <TitleBar
    //         title={this.props.titleBarTitle}
    //         LinkName={this.props.titleBarLink}
    //         importDataGrid={this.importDataGrid}
    //         exportDataGrid={this.exportDataGrid}
    //       />
    //       <LoadingPlaceholder />
    //     </React.Fragment>
    //   );
    // } else if (!this.props.rowData || this.props.rowData.length === 0) {
    //   return (
    //     <React.Fragment>
    //       <TitleBar
    //         title={this.props.titleBarTitle}
    //         LinkName={this.props.titleBarLink}
    //         importDataGrid={this.importDataGrid}
    //         exportDataGrid={this.exportDataGrid}
    //       />
    //       <Segment className="m-2">
    //         <center>
    //           {" "}
    //           <Header>{t("no_records_found") || "NO Record(s) Found"}</Header>
    //         </center>
    //       </Segment>
    //     </React.Fragment>
    //   );
    // } else {
    return (
      <>
        {!this.props.hide ?
          <TitleBarDelivery
            addNewDelivery={this.props.addNewDelivery}
            title={this.props.titleBarTitle}
            LinkName={this.props.titleBarLink}
            handleSearch={this.handleChange}
            handleMetaSearch={this.handleMetaSearch}
            importDataGrid={this.importDataGrid}
            exportDataGrid={this.exportDataGrid}
            exportHidden={this.props.exportHidden}
            radioToggle={this.props.radioToggle}
            toggleView={this.props.toggleView}
            toggle={this.props.toggle}
            baseURL={this.props.baseURL}
            addNewDeliveryModal={this.addNewDeliveryModal}
          />
          : ""}
        {this.props.rowData.length == 0  && this.props.isLoading ? (
          <LoadingPlaceholder />
        ) : (
          <>
            <div className="ag-theme-material agOver">
              <AgGridReact
                domLayout="autoHeight"
                modules={this.state.modules}
                sideBar={this.state.sideBar}
                rowGroupPanelShow={"always"}
                quickFilterText={this.state.searchValue}
                // suppressAutoSize={true}
                columnDefs={this.props.columnDefs}
                defaultColDef={this.state.defaultColDef}
                frameworkComponents={frameworkComponents}
                rowSelection="multiple"
                rowData={this.props.rowData}
                onCellDoubleClicked={this.props.cellDoubleClicked}
                //pagination={true}
                loadingOverlayComponent={this.state.isLoading}
                onRowSelected={this.props.rowSelected}
                paginationPageSize={10}
                onGridReady={this.onGridReady}
                baseURL={this.props.baseURL}
                completeURL={this.props.completeURL}
                deleteURL={this.props.deleteURL}
                keyIndex={this.props.keyIndex}
                onEdit={this.props.onEdit}
                onDelete={this.props.onDelete}
                hideRowEdit={this.props.hideRowEdit}
                hideRowDelete={this.props.hideRowDelete}
                noRowsOverlayComponent={this.state.noRowsOverlayComponent}
                noRowsOverlayComponentParams={
                  this.state.noRowsOverlayComponentParams
                }
                {...this.props}
                onFilterChanged={this.filterChanged}
              />
            </div>
            <div className="life-cycle w3-white ui pagination menu"
          style={this.props?.selectedRows?.length>0?
            { marginBottom: "50px", } :
            {}
          }>
              <Pagination
                defaultActivePage={this.props.currentPage}
                firstItem={null}
                lastItem={null}
                onPageChange={this.props.handlePaginationChange}
                pointing
                secondary
                totalPages={this.props.totalPages}
              />
            </div>
            <ModalEditAddDeliveries
              size="large"
              btime={21}
              reqon={new Date()}
              t={t}
              movement_type={this.state.selectedMovementType}
              OpenModel={this.state.openModalDelivery}
              handleClose={this.setOpenModalDeliveryClose}
              addDeliveryDetails={this.addDeliveryDetails}
              onlyDelivery={true}
              handleMovementType={this.handleMovementType}
            />
          </>)}
      </>
    );
    //   }
  }
}

export default translate("ag_grid")(DeliveryAgGridTable);
